document.addEventListener("DOMContentLoaded", function () {
  // Smooth scroll functionality
  document
    .querySelectorAll('a[href^="#"], button[data-target]')
    .forEach((element) => {
      element.addEventListener("click", function (e) {
        e.preventDefault();

        // Get target ID from href or data-target
        const targetId =
          this.getAttribute("href") || this.getAttribute("data-target");
        if (!targetId) return;

        const targetElement = document.querySelector(targetId);
        if (targetElement) {
          targetElement.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      });
    });

});
